import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { UserService } from '../services/user.service';

export const companyInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);

  // No guessing the company from a stored redirect URL: `companyGuard` calls
  // `selectCompany()` before it issues any company-scoped request, and
  // /api/Auth/me is excluded below, so every request that needs the header
  // already has a selected company. Inferring it from storage meant a stale
  // value decided the `x-company-id` of unrelated requests.
  const company = userService.selectedCompany();

  if (company?.id && !req.url.includes('/api/Auth/me')) {
    req = req.clone({ setHeaders: { 'x-company-id': String(company.id) } });
  }

  return next(req);
};
